<template>
  <div>
    <v-dialog v-model="showReportDialog">
      <report-viewer
        :reportName="Report_Name"
        :dataUrl="Report_URL"
        ref="reportViewer"
        :printOnly="true"
      />   
    </v-dialog>      
       
    <v-dialog v-model="showLeasesDialog" width="500px">
      <v-card>
        <v-card-title>
          <h2>Dog's leases:</h2>
        </v-card-title>
        <v-card-text>
          <div v-if="!!leases && leases.length > 0">
            <div v-for="lease in leases" v-bind:key="lease.leaseId">
              <v-divider horizontal></v-divider>
              <div class="pt-3 pb-3 pr-3 pl-3">
                <h3 :class="!lease.isValid ? 'red--text' : ''">
                  <b>ID #{{ lease.leaseId }}: </b>
                  <span
                    ><localized-date :date="lease.startDate" /> -
                    <localized-date :date="lease.endDate" /></span
                  ><br />
                </h3>
                <span v-if="!lease.isValid" class="red--text">Cancelled</span>
                <CoownersList
                  :owners="lease.lesees"
                  :ownershipType="leaseOwnershipType"
                />
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div>
      <h1>Dog Info</h1>
      <v-alert
        v-for="(error, index) in dogInfo.errors"
        :key="index"
        type="error"
        outlined
      >
        {{ error }}
      </v-alert>
      <v-card class="user-profile-card">
        <v-card-title>
          <v-row>
            <v-col cols="12" sm="9">
              <h4>{{dogInfo.dogPrefix}}</h4>
              <h2>
                {{ dogInfo.name }}
                <v-chip v-if="dogInfo.isDead" small color="red" text-color="white" class="ml-2">
                  Deceased
                </v-chip>
                <v-chip v-if="dogInfo.isInactive" small color="grey lighten-1" text-color="white" class="ml-2">
                  Inactive
                </v-chip>
              </h2>
              <h4>{{dogInfo.dogSuffix}}</h4>
            </v-col>
            <v-col cols="12" sm="3" class="pt-0 pt-sm-3">
              <div class="d-flex flex-column">
                  <v-btn block class="mb-2" color="secondary" v-if="dogInfo.currentUserIsCoowner" v-on:click="showRegCard()">Registration Card</v-btn>
                  <v-btn block class="mb-2" color="secondary" v-if="dogInfo.digitalPedigreeAccessEnabled" v-on:click="showPedigreeReport()">Show Pedigree</v-btn>
                <router-link
                    class="d-block no-text-decoration"
                    :to="`/profile/pedigrees/${dogInfo.dogId?.trim()}`"                    
                  >
                  <v-btn block class="mb-2" color="secondary">
                    Reports & Pedigrees List
                  </v-btn>
                </router-link>  
                <router-link
                    class="d-block no-text-decoration"
                    :to="`/pedigree/order/${dogInfo.dogId?.trim()}?dogName=${dogInfo.name}`"                    
                  >
                  <v-btn block color="secondary">
                    {{ dogInfo.digitalPedigreeAccessEnabled ? 'Order report or pedigree print': 'Order report or pedigree'}}
                  </v-btn>
                </router-link>                       
              </div>
            </v-col>
          </v-row>
        </v-card-title>
        <v-dialog v-model="editDialog" max-width="520" persistent>
          <v-card>
            <v-card-title>Update my dog's details</v-card-title>
            <v-card-text>
              <p class="caption">
                Anything not listed here is maintained by the ASCA office.
              </p>
              <v-form ref="editFormRef" v-model="editFormValid">
              <v-text-field
                v-model="editForm.callName"
                label="Call name"
                :counter="50"
                maxlength="50"
              />
              <v-text-field
                v-model="editForm.chipNumber"
                label="Microchip number"
                :counter="20"
                maxlength="20"
              />
              <v-checkbox v-model="editForm.isInactive" hide-details>
                <template v-slot:label>
                  <div>
                    Mark inactive
                    <div class="caption grey--text">
                      Moves this dog to the end of your list and into Inactive. Only affects your view.
                    </div>
                  </div>
                </template>
              </v-checkbox>
              <v-checkbox v-model="editForm.isDeceased" hide-details class="mt-3">
                <template v-slot:label>
                  <div>
                    Deceased
                    <div class="caption grey--text">
                      Recorded against the dog for everyone. You can uncheck this again.
                    </div>
                  </div>
                </template>
              </v-checkbox>
              <DatepickerFormatted
                v-if="editForm.isDeceased"
                :date="editForm.deathDate"
                label="Date of death (optional)"
                class="mt-2"
                v-on:updateDates="editForm.deathDate = $event.date"
              />
              </v-form>
              <div v-if="editError" class="red--text caption mt-3">{{ editError }}</div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text :disabled="editSaving" @click="editDialog = false">Cancel</v-btn>
              <v-btn
                color="primary"
                :loading="editSaving"
                :disabled="!editFormValid"
                @click="saveMyDog"
              >Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <photo-lightbox v-model="photoDialog" :src="dogInfo.photoUrl" />
        <v-card-text class="pt-0">
          <v-divider class="mt-0 mb-3"></v-divider>
          <v-row>
            <v-col cols="12" sm="3" class="text-center">
              <v-img
                alt="dog"
                :aspect-ratio="1"
                :contain="!dogInfo.photoUrl"
                class="rounded grey lighten-4"
                :class="dogInfo.photoUrl ? 'enlargeable' : 'pa-6'"
                :src="dogInfo.photoUrl || defaultImage"
                @click.native="dogInfo.photoUrl && (photoDialog = true)"
              />
              <div v-if="dogInfo.currentUserIsCoowner" class="mt-2">
                <input
                  ref="photoInput"
                  type="file"
                  accept="image/jpeg,image/png,image/webp"
                  class="d-none"
                  @change="handlePhotoSelected"
                />
                <div>
                  <v-btn small text color="primary" :loading="photoSaving" @click="photoTermsDialog = true">
                    {{ dogInfo.photoUrl ? "Change photo" : "Add photo" }}
                  </v-btn>
                </div>
                <photo-terms-dialog
                  v-model="photoTermsDialog"
                  :has-photo="!!dogInfo.photoUrl"
                  :uploading="photoSaving"
                  :error="photoError"
                  @choose="choosePhoto"
                  @clear-error="photoError = ''"
                />
                <div v-if="dogInfo.photoUrl">
                  <v-btn
                    small
                    text
                    color="red"
                    :disabled="photoSaving"
                    @click="removePhoto"
                  >
                    Remove
                  </v-btn>
                </div>
                <div v-if="photoError" class="red--text caption">{{ photoError }}</div>
              </div>
            </v-col>
            <v-col cols="12" sm="5">
              <p>
                <b>Dog ID: </b> {{ dogInfo.dogId }} <br />                
                <span v-if="dogInfo.currentUserIsCoowner"><b>CHIP #: </b> {{ dogInfo.chipNumber }}<br /></span>
                <span v-if="dogInfo.currentUserIsCoowner"><b>Call name: </b> {{ dogInfo.callName }}<br /></span>
                <b>Gender: </b> {{ dogInfo.gender }} <br />
                <b>Age: </b> {{ dogInfo.age }} Years Old <br />
                <b>Birthdate: </b>
                <span v-if="!!dogInfo.birthdate"><localized-date :date="dogInfo.birthdate" /></span
                ><span v-else>Unknown</span> <br />
                <b>Body: </b>
                <span v-if="!!dogInfo.body">{{ dogInfo.body }} </span
                ><span v-else>Unknown</span><br />
                <b>Trim: </b>
                <span v-if="!!dogInfo.trim">{{ dogInfo.trim }} </span
                ><span v-else>Unknown</span><br />
                <b>Eyes: </b> {{ dogInfo.eyes }} <br />
                <span v-if="dogInfo.currentUserIsCoowner"><b>DNA Status: </b> {{ dogInfo.dnaStatus }} <br /></span>
                <b>Sire: </b>
                <span v-if="!!dogInfo.sire">{{ dogInfo.sire }} </span
                ><span v-else>Unknown</span><br />
                <b>Dam: </b> <span v-if="!!dogInfo.dam">{{ dogInfo.dam }} </span
                ><span v-else>Unknown</span><br />
              </p>
              <v-btn
                v-if="dogInfo.currentUserIsCoowner"
                small
                text
                color="primary"
                class="ml-n1"
                v-on:click="openMyDogEdit()"
              >
                Update details
              </v-btn>
            </v-col>
            <v-col cols="12" sm="4">
              <v-row class="ma-0">
                <v-spacer></v-spacer>
                <v-btn
                  v-if="dogInfo.currentUserIsCoowner && leases.length > 0"
                  light
                  large
                  v-on:click="showLeasesDialog = !showLeasesDialog"
                  color="normal"
                  width="135px"
                  class="mr-5"
                  >Show leases</v-btn
                >
              </v-row>
              <v-row class="ma-0 float-end">   
              <div>               
                <div>
                <router-link
                  v-if="dogInfo.canRegisterLitter"
                  class="no-text-decoration"
                  :to="`/registration/litter/${dogInfo.dogId}`"
                >
                  <v-btn
                    light
                    large
                    color="normal"
                    width="135px"
                    class="mr-5 mt-5 float-end"
                    v-if="dogInfo.canRegisterLitter"
                  >
                    Register Litter
                  </v-btn>
                </router-link>
                <router-link
                  class="no-text-decoration"
                  :to="`/leaserequest/${dogInfo.dogId}`"
                >
                  <v-btn
                    light
                    large
                    color="normal"
                    width="135px"
                    class="mr-5 mt-5 float-end"
                    v-if="dogInfo.canRegisterLease"
                  >
                    Add Lease
                  </v-btn>             
                </router-link>
                </div><br>
              </div>
              </v-row>
            </v-col>
          </v-row>
          <!-- Full card width rather than sharing the details column: at a third of
               the card each name wrapped onto three lines. Side by side from sm up,
               stacked below it. mx-0 keeps the row's negative margins off the card. -->
          <v-row class="mx-0" dense>
            <v-col cols="12" :sm="hasBreeders ? 6 : 12" class="py-0 pl-0 pr-sm-4">
              <CoownersList
                :owners="dogInfo.owners"
                :ownershipType="dogOwnershipType"
              />
            </v-col>
            <v-col v-if="hasBreeders" cols="12" sm="6" class="py-0 pl-0">
              <CoownersList
                :owners="dogInfo.breeders"
                :ownershipType="litterOwnershipType"
                :customHeader="breederHeader"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card
        v-if="dogInfo.dogCerts && dogInfo.dogCerts.length > 0"
        class="user-profile-card"
      >
        <v-card-title class="titles-card-header">
          <h3>Titles</h3>
          <v-spacer />
          <v-select
            v-if="hasMultipleTitles"
            v-model="titleSort"
            :items="titleSortOptions"
            item-text="text"
            item-value="value"
            label="Sort titles"
            dense
            outlined
            hide-details
            class="title-sort-select"
          />
        </v-card-title>
        <v-card-subtitle
          v-if="dogInfo.currentUserIsCoowner"
          class="text-caption pb-0"
        >
          Click any title to reprint the certificate.
        </v-card-subtitle>
        <v-card-text>
          <span v-for="title in displayedDogCerts" :key="title.certificateId">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="title-award mt-7 mb-7" v-bind="attrs" v-on="on">
                  <component
                    :is="dogInfo.currentUserIsCoowner ? 'button' : 'span'"
                    :type="dogInfo.currentUserIsCoowner ? 'button' : undefined"
                    class="fa-layers award title-award-ribbon"
                    :class="{ 'title-award-button': dogInfo.currentUserIsCoowner }"
                    @click="onAwardClick(title)"
                  >
                    <font-awesome-icon size="4x" icon="award" />
                    <span class="fa-layers-text award-text">{{ title.title }}</span>
                  </component>
                </span>
              </template>
              <span>
                <span>{{ title.description }}</span
                ><br />
                <span>Awarded: <localized-date :date="title.showDate" /></span>
              </span>
            </v-tooltip>
          </span>
        </v-card-text>
      </v-card>
      <v-row class="mx-0 points-summary-row">
        <v-col class="points-summary-col" v-if="
              !!dogInfo &&
              !!dogInfo.pointsSummary &&
              dogInfo.pointsSummary.regular +
                dogInfo.pointsSummary.gambler +
                dogInfo.pointsSummary.jumper >
                0
            ">
          <v-card class="user-profile-card" >
            <v-card-title>
              Working on {{dogInfo.pointsSummary.atchTitle}}
            </v-card-title>
            <v-card-text>
              <span>Regular:</span><br />
              <h1>{{ dogInfo.pointsSummary.regular }}</h1>
              <br />
              <span>Gamblers:</span><br />
              <h1>{{ dogInfo.pointsSummary.gambler }}</h1>
              <br />
              <span>Jumpers:</span><br />
              <h1>{{ dogInfo.pointsSummary.jumper }}</h1>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="points-summary-col" v-if="
              !!dogInfo &&
              !!dogInfo.pointsSummary &&
              dogInfo.pointsSummary.regularACE +
                dogInfo.pointsSummary.gamblerACE +
                dogInfo.pointsSummary.jumperACE >
                0
            ">
          <v-card class="user-profile-card" >
            <v-card-title>
              Working on {{dogInfo.pointsSummary.aceTitle}}
            </v-card-title>
            <v-card-text>
              <span>Regular:</span><br />
              <h1>{{ dogInfo.pointsSummary.regularACE }}</h1>
              <br />
              <span>Gamblers:</span><br />
              <h1>{{ dogInfo.pointsSummary.gamblerACE }}</h1>
              <br />
              <span>Jumpers:</span><br />
              <h1>{{ dogInfo.pointsSummary.jumperACE }}</h1>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="points-summary-col" v-if="
              !!dogInfo &&
              !!dogInfo.pointsSummary &&
              !!dogInfo.pointsSummary.otch
              && dogInfo.pointsSummary.otch.totalPoints > 0
            ">
          <v-card class="user-profile-card" >
            <v-card-title>
              Working on {{ dogInfo.pointsSummary.otch.title}}    
            </v-card-title>
            <v-card-text>
              <span>Total points:</span><br />
              <h1>{{ dogInfo.pointsSummary.otch.totalPoints }}</h1>
              <br />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="points-summary-col" v-if="
              !!dogInfo &&
              !!dogInfo.pointsSummary &&
              !!dogInfo.pointsSummary.otcH_O
              && dogInfo.pointsSummary.otcH_O.totalPoints > 0
            ">
          <v-card class="user-profile-card" >
            <v-card-title>
              Working on {{ dogInfo.pointsSummary.otcH_O.title}}    
            </v-card-title>
            <v-card-text>
              <span>Total points:</span><br />
              <h1>{{ dogInfo.pointsSummary.otcH_O.totalPoints }}</h1>
              <br />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="points-summary-col" v-if="
              !!dogInfo &&
              !!dogInfo.pointsSummary && !!dogInfo.pointsSummary.rtch 
              && !!dogInfo.pointsSummary.rtch.excellentTotalPoints + dogInfo.pointsSummary.rtch.masterTotalPoints > 0">
          <v-card class="user-profile-card">
            <v-card-title>
              Working on {{ dogInfo.pointsSummary.rtch.title}}              
            </v-card-title>
            <v-card-text>
              <span>RTCH Excellent:</span><br />
              <h1>{{ dogInfo.pointsSummary.rtch.excellentTotalPoints }}</h1>
              {{ dogInfo.pointsSummary.rtch.excellent195ScoresCount }} scores >=195  from
                    {{ dogInfo.pointsSummary.rtch.excellent195ScoresJudgesCount }} judges
              <br /><br />
              <span>RTCH Masters:</span><br />
              <h1>{{ dogInfo.pointsSummary.rtch.masterTotalPoints }}</h1>
              {{ dogInfo.pointsSummary.rtch.master195ScoresCount }} scores >=195  from
                    {{ dogInfo.pointsSummary.rtch.master195ScoresJudgesCount }} judges
              <br />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="points-summary-col" v-if="!!dogInfo && !!dogInfo.pointsSummary && !!dogInfo.pointsSummary.scch">
          <v-card class="user-profile-card">
            <v-card-title>
              Working on {{ dogInfo.pointsSummary.scch.nextTitle}}                   
            </v-card-title>
            <v-card-text>
              <p>
                <span><b>Points total: </b>{{dogInfo.pointsSummary.scch.pointsTotal}}
                <br/>({{dogInfo.pointsSummary.scch.majorWinsCount}} <b>major wins</b> from {{dogInfo.pointsSummary.scch.majorWinsJudgesCount}} <b>different judges</b>
                and remaining scores from {{dogInfo.pointsSummary.scch.otherScoresJudgesCount}} <b>other judges</b>)</span><br/>
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <show-results-table
        v-if="!!dogInfo && !!showResults && showResults.data && showResults.data.length > 0"
        :results="showResults.data"
        :dog-id="dogId"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";
import PhotoLightbox from "@/components/common/PhotoLightbox.vue";
import PhotoTermsDialog, { PHOTO_TERMS_VERSION } from "@/components/common/PhotoTermsDialog.vue";
import ReportViewer from "@/components/Admin/Reports/ReportViewer.vue";
import ShowResultsTable from "@/components/Portal/ShowResultsTable.vue";
import DatepickerFormatted from "@/components/common/inputs/DatepickerFormatted.vue";
import dogService from "@/services/dogService";
import { resizeImage } from "@/helpers/resize-image";
import { getErrorMessage } from "@/services/errorHandler";
import { UserInfo } from "@/types/User";

const defaultImage = require('@/assets/logo.svg');

export default Vue.extend({
  name: "DogInfo",
  components: {
    PhotoLightbox,
    PhotoTermsDialog,
    CoownersList,
    ReportViewer,
    ShowResultsTable,
    DatepickerFormatted
  },
  data: function () {
    return {
      defaultImage,
      dogInfo: {} as any,
      editDialog: false,
      editSaving: false,
      editError: "",
      editForm: {
        callName: "",
        chipNumber: "",
        isDeceased: false,
        deathDate: null as Temporal.PlainDate | null,
        isInactive: false,
      },
      editFormValid: true,
      photoSaving: false,
      photoTermsDialog: false,
      photoDialog: false,
      photoError: "",
      showResults: {} as any,
      leases: [] as any[],
      showLeasesDialog: false,
      titleSort: "alphabetical",
      titleSortOptions: [
        { text: "Alphabetical", value: "alphabetical" },
        { text: "Date earned", value: "date" },
      ],
      selectedTitle: "",
      Report_Name: 'Asca.Api.Reports.rpt8110_Title_Certificate.rdlx',
      Report_URL: '`/Admin/reports/certificate/${selectedTitle}`',
      showReportDialog: false,
      showReportDialogFull: false,
      showPedigreeDialog: false,
      showPedigreeSmallDialog: false,
      showRegCardDialog: false,
      dogInfoLoadId: 0,
    };
  },
  
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    displayedDogCerts: function (): any[] {
      const titles = this.dogInfo.dogCerts || [];
      if (this.titleSort === "date") return titles;

      return [...titles].sort((left: any, right: any) =>
        left.title.trim().localeCompare(right.title.trim())
      );
    },
    hasMultipleTitles: function (): boolean {
      return (this.dogInfo.dogCerts?.length || 0) > 1;
    },
    dogOwnershipType: function () {
      return OwnershipType.Dog;
    },
    litterOwnershipType: function () {
      // The breeders are the litter's owners, so the primary marker means what it
      // means on a litter.
      return OwnershipType.Litter;
    },
    hasBreeders: function (): boolean {
      // Dogs registered without a litter have none to show, which is most of the
      // older ones.
      return !!this.dogInfo.breeders && this.dogInfo.breeders.length > 0;
    },
    breederHeader: function (): string {
      return this.dogInfo.breeders && this.dogInfo.breeders.length > 1
        ? "Breeders"
        : "Breeder";
    },
    leaseOwnershipType: function () {
      return OwnershipType.Lease;
    },
  },
  methods: {
    loadDogInfo: function () {
      const loadId = ++this.dogInfoLoadId;
      const dogId = this.dogId;
      if (!dogId || !this.userInfo?.personId) return;

      dogService
        .getDogById(dogId, false)
        .then((res) => {
          if (loadId !== this.dogInfoLoadId) return;
          this.dogInfo = res;

          dogService
            .getDogPointsById(dogId)
            .then((points) => {
              if (loadId !== this.dogInfoLoadId) return;
              this.$set(this.dogInfo, "pointsSummary", points.pointsSummary);
              if (points.errors?.length) {
                this.$set(this.dogInfo, "errors", [...(this.dogInfo.errors || []), ...points.errors]);
              }
            })
            .catch((error) => {
              if (loadId === this.dogInfoLoadId) this.$handleError(error);
            });
        })
        .catch((error) => {
          if (loadId === this.dogInfoLoadId) this.$handleError(error);
        });
    },
    openMyDogEdit: function () {
      this.editError = "";
      this.editForm = {
        callName: this.dogInfo.callName ?? "",
        chipNumber: this.dogInfo.chipNumber ?? "",
        isDeceased: !!this.dogInfo.isDead,
        deathDate: this.dogInfo.deathDate ?? null,
        isInactive: !!this.dogInfo.isInactive,
      };
      this.editDialog = true;
    },
    saveMyDog: async function () {
      this.editSaving = true;
      this.editError = "";
      try {
        const res = await dogService.updateMyDog(this.dogInfo.dogId, {
          callName: this.editForm.callName,
          chipNumber: this.editForm.chipNumber,
          isDeceased: this.editForm.isDeceased,
          // Left blank for a dog whose date nobody remembers, which is most old ones.
          deathDate: this.editForm.isDeceased ? this.editForm.deathDate || null : null,
          isInactive: this.editForm.isInactive,
        });

        if (res.success) {
          this.editDialog = false;
          await this.refreshMyDogInfo();
        } else {
          this.editError = res.errorMessage;
        }
      } catch (e: any) {
        // Report it, but leave the dialog open: closing here would discard everything
        // typed, including the value that caused the failure.
        this.$handleError(e);
        this.editError = "Those changes could not be saved. Check the values and try again.";
      } finally {
        this.editSaving = false;
      }
    },
    refreshMyDogInfo: function (): Promise<void> {
      const loadId = ++this.dogInfoLoadId;
      const dogId = this.dogId;
      return dogService
        .getDogById(dogId)
        .then((res) => {
          if (loadId !== this.dogInfoLoadId) return;
          this.dogInfo = res;
        });
    },
    choosePhoto: function () {
      this.photoError = "";
      (this.$refs.photoInput as HTMLInputElement).click();
    },
    handlePhotoSelected: async function (event: Event) {
      const input = event.target as HTMLInputElement;
      const file = input.files && input.files[0];
      input.value = "";

      if (!file) return;

      this.photoSaving = true;
      this.photoError = "";
      try {
        const resized = await resizeImage(file);
        const res = await dogService.uploadDogPhoto(this.dogInfo.dogId, resized, PHOTO_TERMS_VERSION);

        if (res.success) {
          this.photoTermsDialog = false;
          await this.refreshMyDogInfo();
        } else {
          this.photoError = res.errorMessage;
        }
      } catch (e: any) {
        this.photoError = getErrorMessage(e);
      } finally {
        this.photoSaving = false;
      }
    },
    removePhoto: async function () {
      this.photoSaving = true;
      try {
        const res = await dogService.deleteDogPhoto(this.dogInfo.dogId);

        if (res.success) {
          await this.refreshMyDogInfo();
        } else {
          this.photoError = res.errorMessage;
        }
      } finally {
        this.photoSaving = false;
      }
    },
    showPedigreeReport: function (){
      this.Report_Name = "Asca.Api.Reports.rpt3240_Dog_Pedigree_Report_New2.rdlx";
      this.Report_URL = `/reports/pedigree/${encodeURIComponent(this.dogId?.trim())}`;
      this.showReportDialog = true;
    },
    showRegCard: function (){
      this.Report_Name = "Asca.Api.Reports.rpt3210_Dog_Reg_Certificate.rdlx";
      this.Report_URL = `/reports/registration/${encodeURIComponent(this.dogId?.trim())}`;
      this.showReportDialog = true;
    },
    onAwardClick: function (title: any) {
      if (this.dogInfo.currentUserIsCoowner) this.showTitle(title);
    },
    showTitle: function (title: any){
      (title.isSuffix && !(title.title.includes('DNA'))) ? this.Report_Name= 'Asca.Api.Reports.rpt8110_Title_Certificate.rdlx' : this.Report_Name= 'Asca.Api.Reports.rpt8111_Title_Certificate_Full.rdlx';
      this.selectedTitle = title.certificateId;
      this.Report_URL = '/Admin/reports/certificate/'+this.selectedTitle
      this.showReportDialog = true;
    },
    
  },
  created: function () {
    if (this.dogId && this.userInfo) {
      this.loadDogInfo();
      dogService
        .getDogShowResultsById(this.dogId)
        .then((res) => {
          this.showResults = res;
        })
        .catch(this.$handleError);
      dogService
        .getDogLeases(this.dogId)
        .then((res) => {
          this.leases = res.data;
        })
        .catch(this.$handleError);
    }
  },
  watch: {
    dogId: function (newVal: String) {
      this.loadDogInfo();
      dogService
        .getDogShowResultsById(this.dogId)
        .then((res) => {
          this.showResults = res;
        })
        .catch(this.$handleError);
      dogService
        .getDogLeases(this.dogId)
        .then((res) => {
          this.leases = res.data;
        })
        .catch(this.$handleError);
    },
    userInfo: function (newVal: object) {
      this.loadDogInfo();
      dogService
        .getDogShowResultsById(this.dogId)
        .then((res) => {
          this.showResults = res;
        })
        .catch(this.$handleError);
      dogService
        .getDogLeases(this.dogId)
        .then((res) => {
          this.leases = res.data;
        })
        .catch(this.$handleError);
    },
    
  },
  props: {
    dogId: { type: String },
  },
});
</script>

<style lang="scss" scoped>
.points-summary-row {
  gap: 16px;
  margin-top: 16px;
}

.titles-card-header {
  gap: 16px;
}

.title-sort-select {
  flex: 0 1 260px;
  max-width: 260px;
}

.points-summary-row:empty {
  margin-top: 0;
}

.points-summary-col {
  display: flex;
  flex: 1 1 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0;
}

.points-summary-col > .user-profile-card {
  height: 100%;
  margin-top: 0;
}

@media (min-width: 600px) {
  .points-summary-col {
    flex-basis: calc((100% - 32px) / 3);
  }
}

// The action buttons stack in a narrow column whose labels are longer than it is.
// Without wrapping, "Order Report or Pedigree Print" reaches past the card and
// scrolls the page sideways - on a phone, and on a desktop window too.
::v-deep .v-card__title {
  .v-btn {
    white-space: normal;
    height: auto;
    min-height: 36px;
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .v-btn__content {
    white-space: normal;
    // The app breaks mid-word everywhere, which renders a wrapped label as
    // "REGISTRATION CAR / D". Break at spaces instead.
    word-break: normal;
    flex: 1 1 auto;
  }
}

@media (max-width: 599px) {
  .titles-card-header .title-sort-select {
    flex-basis: 100%;
    max-width: none;
  }

  ::v-deep .v-card__title {
    word-break: normal;

    // At 30px the dog's name cannot fit a small phone, and wrapping a title
    // mid-word reads worse than a smaller one.
    h2 {
      font-size: 1.4rem;
      line-height: 1.25;
    }

    // A flex v-card-title will not shrink the row below its content, so the row
    // needs both its negative margins cancelled and permission to shrink.
    > .row {
      margin-left: 0;
      margin-right: 0;
    }

    > .row > .col-12 {
      min-width: 0;
    }
  }
}
</style>
